import { useMultistepModal, MultistepModalProvider } from './context';

export const MultistepModal = {
  useMultistepModal: useMultistepModal,
  Provider: MultistepModalProvider,
};
